// extracted by mini-css-extract-plugin
module.exports = {"scroll":"ScrollDown_scroll__2QQWE","fade_move_down":"ScrollDown_fade_move_down__1RF4Z","scroll_wrap":"ScrollDown_scroll_wrap__37Wc7"};